var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompareBroker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01_AtAGlance",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A_01",
    transform: "translate(-111.000000, -510.000000)",
    fill: "#5b5b5b",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(95.000000, 455.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(1.000000, 39.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_1375867_cc",
    transform: "translate(15.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.845,32.155 L17.357,26.6665 L15,29.0235 L17.643,31.6665 L11.665,31.665 C9.824,31.665 8.3335,30.1725 8.3335,28.3315 L8.3335,13.097 C11.2045,12.3535 13.3335,9.769 13.3335,6.6665 C13.3335,2.9855 10.348,0 6.6665,0 C2.985,0 0,2.9855 0,6.6665 C0,9.769 2.129,12.3535 5,13.097 L5,28.3315 C5,32.013 7.9835,35 11.665,35 L17.643,35 L15.0015,37.643 L17.3585,40 L22.845,34.5115 C23.496,33.8625 23.496,32.806 22.845,32.155 Z M6.6665,10 C4.8255,10 3.3335,8.5075 3.3335,6.6665 C3.3335,4.826 4.8255,3.333 6.6665,3.333 C8.5075,3.333 10,4.826 10,6.6665 C10,8.5075 8.5075,10 6.6665,10 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,26.903 L35,11.6685 C35,7.987 32.0165,5 28.335,5 L22.357,5 L24.9985,2.3565 L22.6415,0 L17.155,5.4885 C16.504,6.138 16.504,7.194 17.155,7.8455 L22.6435,13.334 L25,10.9765 L22.357,8.3335 L28.335,8.335 C30.176,8.335 31.6665,9.8275 31.6665,11.6685 L31.6665,26.903 C28.7975,27.6465 26.6665,30.231 26.6665,33.3335 C26.6665,37.015 29.652,40 33.3335,40 C37.015,40 40,37.015 40,33.3335 C40,30.231 37.8695,27.6465 35,26.903 Z M33.3335,36.6665 C31.4925,36.6665 30,35.1745 30,33.3335 C30,31.4925 31.4925,30 33.3335,30 C35.1745,30 36.6665,31.4925 36.6665,33.3335 C36.6665,35.1745 35.1745,36.6665 33.3335,36.6665 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareBroker);
export default __webpack_public_path__ + "static/media/compare-broker.dc602d8b67f4d3ff8b8b81c6fb58999d.svg";
export { ForwardRef as ReactComponent };